import {
    generateDefaultState,
    getActionTypes,
} from '../../../utils/reduxHelper';

export const priorityActions = getActionTypes('priority', [
    'GET_ALL'
]);

export const timeZoneActions = getActionTypes('timeZone', [
    'GET_ALL'
]);

export const taskTypeActions = getActionTypes('taskType', [
    'GET_ALL'
]);

export const repeatActions = getActionTypes('repeat', [
    'GET_ALL'
]);

export const progressActions = getActionTypes('progress', [
    'GET_ALL'
]);

export const storeActions = getActionTypes('store', [
    'GET_ALL'
]);

export const siteGroupListActions = getActionTypes('siteGroupList', [
    'GET_ALL'
]);

export const userListActions = getActionTypes('userList', [
    'GET_ALL'
]);

export const rolesListActions = getActionTypes('rolesList', [
    'GET_ALL'
]);

export const reminderActions = getActionTypes('reminder', [
    'GET_ALL'
]);

export const actions = {
    ...priorityActions,
    ...timeZoneActions,
    ...taskTypeActions,
    ...repeatActions,
    ...progressActions,
    ...storeActions,
    ...siteGroupListActions,
    ...userListActions,
    ...reminderActions,
    ...rolesListActions
}

export const initialCommonState = {
    ...generateDefaultState('priority', [
        'GET_ALL'
    ]),

    ...generateDefaultState('timeZone', [
        'GET_ALL'
    ]),
    ...generateDefaultState('taskType', [
        'GET_ALL'
    ]),
    ...generateDefaultState('repeat', [
        'GET_ALL'
    ]),
    ...generateDefaultState('progress', [
        'GET_ALL'
    ]),
    ...generateDefaultState('store', [
        'GET_ALL'
    ]),
    ...generateDefaultState('siteGroupList', [
        'GET_ALL'
    ]),
    ...generateDefaultState('userList', [
        'GET_ALL'
    ]),
    ...generateDefaultState('reminder', [
        'GET_ALL'
    ]),
    ...generateDefaultState('rolesList', [
        'GET_ALL'
    ]),
};
